<!--HEADER: steht schon waehrend des Ladens, damit die Seite nach der Zubuchung nicht leer ist.
    Nur bei einem Ladefehler entfaellt er - eine Erfolgsmeldung ueber einer Fehlermeldung waere
    widerspruechlich.-->
<div class="additional-booking-ordered__header row" id="additionalBookingOrderedHeader"
     *ngIf="errors.length === 0">
  <div class="additional-booking-ordered__header-col col-12">
    <h3 class="additional-booking-ordered__intro"
        *appApplyIfNotEmpty="translationService.getTranslation('additionalBooking_ordered_title')"
        [innerHTML]="translationService.getTranslation('additionalBooking_ordered_title')"></h3>
  </div>
  <div class="additional-booking-ordered__header-col col-12">
    <p class="additional-booking-ordered__description"
       *appApplyIfNotEmpty="translationService.getTranslation(descriptionKey)"
       [innerHTML]="translationService.getTranslation(descriptionKey)"></p>
  </div>
</div>

<div class="additional-booking-ordered__spinner" style="text-align: center;" *ngIf="isLoading">
  <app-loading-spinner></app-loading-spinner>
</div>

<ng-container *ngIf="!isLoading">
  <app-general-errors [errors]="errors"></app-general-errors>

  <!--Angebote, deren Zubuchung gescheitert ist: der Kunde muss sich dafuer an den Verlag wenden-->
  <div class="alert alert-warning additional-booking-ordered__not-booked mt-2" id="additionalBookingOrderedNotBooked"
       *ngIf="notBookedCount > 0">
    <p class="additional-booking-ordered__not-booked-hint" [innerHTML]="notBookedHint"></p>
    <ul class="additional-booking-ordered__not-booked-list" *ngIf="notBookedOffers.length > 0">
      <li *ngFor="let offer of notBookedOffers">{{ offer }}</li>
    </ul>
  </div>

  <mat-card class="additional-booking-ordered mt-2" *ngIf="orders.length > 0">
    <!--Je zugebuchtem Abo ein Datenblock; mehrere sind durch eine Trennlinie getrennt-->
    <ng-container *ngFor="let order of orders; let first = first">
      <mat-divider class="additional-booking-ordered__divider" *ngIf="!first"></mat-divider>
      <div class="row additional-booking-ordered__data">
        <ng-container *ngIf="order.productDescription">
          <div class="col-6" [innerHTML]="translationService.getTranslation('order_object')"></div>
          <div class="col-6">{{ order.productDescription }}</div>
        </ng-container>
        <ng-container *ngIf="order.variantDescription">
          <div class="col-6" [innerHTML]="translationService.getTranslation('order_edition')"></div>
          <div class="col-6">{{ order.variantDescription }}</div>
        </ng-container>
        <ng-container *ngIf="order.subId">
          <div class="col-6" [innerHTML]="translationService.getTranslation('order_id')"></div>
          <div class="col-6">{{ order.subId }}</div>
        </ng-container>
        <ng-container *ngIf="order.validDate">
          <div class="col-6" [innerHTML]="translationService.getTranslation('period')"></div>
          <div class="col-6">
            {{ order.validDate.validFrom | date }} -
            {{ order.validDate.validUntil
               ? (order.validDate.validUntil | date)
               : translationService.getTranslation('subscription_endless') }}
          </div>
        </ng-container>
      </div>
    </ng-container>

    <div class="additional-booking-ordered__actions">
      <button mat-raised-button color="primary" (click)="continueBooking()"
              [innerHTML]="translationService.getTranslation('additionalBooking_button_continue')"></button>
      <button mat-raised-button class="additional-booking-ordered__subscriptions-btn"
              (click)="goToSubscriptions()"
              [innerHTML]="translationService.getTranslation('additionalBooking_button_toSubscriptions')"></button>
    </div>
  </mat-card>
</ng-container>
